<template>
    <svg
        class="flex-shrink-0"
        :class="`${block}__icon`"
        :width="width"
        :height="height"
        viewBox="0 0 16 10"
        :fill="iconColor"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.17031 8.82969C8.52397 9.47603 7.47603 9.47603 6.82969 8.82969L1.17031 3.17031C0.523965 2.52397 0.523965 1.47603 1.17031 0.829688C1.81666 0.183343 2.86459 0.183343 3.51093 0.829688L8 5.31875L12.4891 0.829688C13.1354 0.183343 14.1833 0.183343 14.8297 0.829689C15.476 1.47603 15.476 2.52397 14.8297 3.17031L9.17031 8.82969Z"
            fill="#00A8EC"
        />
    </svg>
</template>

<script>
export default {
    name: "iconChevron",
    props: {
        block: {
            type: String,
            default: "accordion",
        },
        width: {
            type: [Number, String],
            default: 16,
        },
        height: {
            type: [Number, String],
            default: 16,
        },
        iconColor: {
            type: String,
            default: "currentColor",
        },
    },
};
</script>

<style></style>
